module.exports = __webpack_public_path__ + "static/Cars-f314d8ebc7ab0a986af72cd2ec72e482.png";